import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalHeaderComponent,
    LoaderComponent
  ],
  templateUrl: './product-form.component.html',
  styleUrl: './product-form.component.scss'
})
export class ProductFormComponent implements OnChanges {
  @Input() item: any = {};
  @Input() modalInstance: any = null;

  modalTitle: string = 'Product toevoegen';
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;
  modalStyle: boolean = false;
  statusList: any[] = [
    { id: 'available', 'name': 'available' },
    { id: 'not-yet-available', 'name': 'not-yet-available' },
    { id: 'limited-available', 'name': 'limited-available' },
    { id: 'temporary-not-available', 'name': 'temporary-not-available' },
    { id: 'no-longer-available', 'name': 'no-longer-available' },
    { id: 'will-never-be-available', 'name': 'will-never-be-available' },
    { id: 'not-available-or-usable', 'name': 'not-available-or-usable' }
  ];

  productTypeOptions: any[] = [
    { id: 'digital', name: 'digital' },
    { id: 'physical', name: 'physical' }
  ];

  shippingCategoryOptions: any[] = [
    { id: '', name: 'Geen' },
    { id: 'category_a', name: 'Categorie A (60)' },
    { id: 'category_b', name: 'Categorie B (40)' },
    { id: 'category_c', name: 'Categorie C (30)' },
    { id: 'category_d', name: 'Categorie D (25)' }
  ];

  copyrightOptions: any[] = [
    "cc-by-40",
    "cc-by-sa-40",
    "cc-by-nc-40",
    "cc-by-nc-sa-40",
    "cc-by-nd-40",
    "cc-by-nc-nd-40",
    "cc-by-30",
    "cc-by-sa-30",
    "cc-by-nc-30",
    "cc-by-nc-sa-30",
    "cc-by-nd-30",
    "cc-by-nc-nd-30",
    "yes",
    "no"
  ]

  constructor(
    private apiService: ApiService,
    public activeModal: NgbActiveModal
  ) {
    this.item = {};
  }

  ngOnChanges(changes: any) {
    this.loading = true;
    this.item = {};

    this.errorMessage = {};
    this.errors = {};
    this.getItem();
  }

  afterSave() {
    this.activeModal.close(true);
  }

  get formattedFirstPublishedDate(): string {
    return this.item['first_published_date']?.split(' ')[0];
  }

  set formattedFirstPublishedDate(value: string) {
    this.item['first_published_date'] = value ? `${value} 00:00:00` : null;
  }

  get formattedEndOfLifeDate(): string {
    return this.item['end_of_life_date']?.split(' ')[0];
  }

  set formattedEndOfLifeDate(value: string) {
    this.item['end_of_life_date'] = value ? `${value} 00:00:00` : null;
  }


  replaceDutchPricingToEnglish(dutchPrice: string | number): string {
    if (typeof dutchPrice !== 'string') {
      dutchPrice = String(dutchPrice); // Convert to string if it's a number
    }

    // Check if the input already uses a dot as the decimal separator
    if (dutchPrice.includes('.') && !dutchPrice.includes(',')) {
      return dutchPrice; // Already in English format, return as is
    }

    // Remove dots used as thousand separators
    const withoutThousandSeparator = dutchPrice.replace(/\.(?=\d{3})/g, '');

    // Replace comma with a dot for the decimal separator
    const englishPrice = withoutThousandSeparator.replace(',', '.');

    return englishPrice;
  }

  save() {
    let self = this;

    self.reset();
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    this.item['price'] = this.replaceDutchPricingToEnglish(this.item['price']);

    let method: string = 'put';
    if (!this.item['id'] || this.item['id'] === '') {
      return this.apiService.post('/office/products', this.item).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      return this.apiService.put('/office/products/' + this.item['id'], this.item).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces(response: any) {
    let self = this;
    self.item = response;
    self.afterSave();
    setTimeout(function () {
      self.loading = false;
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }

    self.loading = false;
  }

  validatePriceValue(event: any) {
    const input = event.target;
    let value = input.value;

    // Replace commas with dots
    value = value.replace(/,/g, '.');

    // Remove all non-digit and non-dot characters
    value = value.replace(/[^0-9.]/g, '');

    // Keep only the first dot
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    input.value = value;
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  getItem() {
    let itemId = this.item['id'];
    let self = this;

    self.reset();
    if (itemId === '') {
      return;
    }
    return this.apiService.get('/office/products/' + itemId).then(function (response: any) {
      self.item = response;
      if (self.item['id']) {
        self.modalTitle = 'Wijzig product';
      } else {
        self.modalTitle = 'Product toevoegen';
      }

      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
